import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "apc_ship_loc";

export const MX_STATES = ["Aguascalientes", "Baja California", "Baja California Sur", "Campeche", "Chiapas", "Chihuahua", "Ciudad de México", "Coahuila", "Colima", "Durango", "Estado de México", "Guanajuato", "Guerrero", "Hidalgo", "Jalisco", "Michoacán", "Morelos", "Nayarit", "Nuevo León", "Oaxaca", "Puebla", "Querétaro", "Quintana Roo", "San Luis Potosí", "Sinaloa", "Sonora", "Tabasco", "Tamaulipas", "Tlaxcala", "Veracruz", "Yucatán", "Zacatecas"];

export const loadLocation = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; } };
export const saveLocation = (loc) => { try { loc ? localStorage.setItem(KEY, JSON.stringify(loc)) : localStorage.removeItem(KEY); } catch { /* ignore */ } };

export const detectByIp = async () => {
  const { data } = await axios.get(`${API}/public/geo`);
  if (!data?.detected || !data.city) return null;
  if (data.country && data.country !== "MX") return null;
  return { state: data.state || "", city: data.city, source: "ip" };
};

export const detectByGps = () => new Promise((resolve, reject) => {
  if (!navigator.geolocation) return reject(new Error("Tu navegador no permite ubicación"));
  navigator.geolocation.getCurrentPosition(async (pos) => {
    try {
      const { latitude, longitude } = pos.coords;
      const { data } = await axios.get(`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=es`);
      const city = data.city || data.locality || data.principalSubdivision || "";
      if (!city) return reject(new Error("No pude identificar tu ciudad"));
      resolve({ state: data.principalSubdivision || "", city, source: "gps" });
    } catch { reject(new Error("No pude identificar tu ciudad")); }
  }, () => reject(new Error("No diste permiso de ubicación")), { timeout: 8000, maximumAge: 600000 });
});

export const quoteShipping = async (ids, loc) => {
  const { data } = await axios.get(`${API}/public/shipping/quote`, { params: { ids: ids.join(","), state: loc?.state || "", city: loc?.city || "" } });
  return data;
};

export const fetchShippingConfig = () => axios.get(`${API}/public/shipping/config`).then((r) => r.data);
